import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'fuelType'
})
export class FuelTypePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string, includeDetails: boolean = true): string {
    if (!value || value.trim() === '') {
      return '';
    }

    const gasolineKeywords = ['gasoline', 'gas (gasoline)', 'petrol', 'benzyna', 'benzin', '92', '95', '98', '100'];
    const ethanolKeywords = ['ethanol', 'etanol', 'e85'];
    const dieselKeywords = ['diesel', 'diesel fuel', 'olej napedowy', 'olej napędowy'];
    const gasKeywords = ['gas', 'lpg', 'cng', 'lng', 'gaz'];

    const items = value
      .split(',')
      .map(item => item.trim().toLowerCase())
      .filter(item => item.length > 0);
    const numericValues = items
      .filter(item => !isNaN(Number(item)))
      .map(Number)
      .sort((a, b) => a - b);

    const fuelTypes = new Set<string>();

    if (items.some(item => gasolineKeywords.includes(item))) {
      const label = this.translate.instant('common.gasoline');
      const numbers = includeDetails && numericValues.length > 0 ? numericValues.join('/') : null;
      fuelTypes.add(numbers ? `${label} ${numbers}` : label);
    }

    if (items.some(item => ethanolKeywords.includes(item))) {
      fuelTypes.add(this.translate.instant('common.ethanol'));
    }

    if (items.some(item => dieselKeywords.includes(item))) {
      fuelTypes.add(this.translate.instant('common.diesel'));
    }

    if (items.some(item => gasKeywords.includes(item))) {
      fuelTypes.add(this.translate.instant('common.gas'));
    }

    // Jeśli nie ma specyficznych słów kluczowych, ale są liczby, traktuj je jako benzynę
    if (fuelTypes.size === 0 && numericValues.length > 0) {
      const label = this.translate.instant('common.gasoline');
      fuelTypes.add(includeDetails ? `${label} ${numericValues.join('/')}` : label);
    }

    if (fuelTypes.size > 0) {
      return Array.from(fuelTypes).join(', ');
    }

    // Preserve original value for unknown formats instead of hiding it in the UI.
    return value.trim();
  }
}
